/**
 * 業務エリア未設定時の誘導表示 (ハードエラーにしない)。
 * 設定画面への遷移は呼び出し側 (page) が onGoToSettings で握り、本 view は純表示に保つ。
 */
import type { MouseEvent } from 'react'

import { useTranslation } from 'react-i18next'

import { Flex, SecondaryButton, Text } from '@enechain/ecloud-designsystem'

type Props = {
  onGoToSettings: (event?: MouseEvent) => void
}

export const AreaNotSetView = ({
  onGoToSettings,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
      gap={4}
      height="300px"
      paddingX={4}
    >
      <Text color="Text.midEmphasis" fontSize="sm">
        {t('page:demandForecastDaily.error.areaNotSet')}
        {/* TODO: P-1 PdM文言確定 */}
      </Text>
      <SecondaryButton onClick={(e?: MouseEvent) => onGoToSettings(e)}>
        {t('page:demandForecastDaily.error.goToSettings')}
        {/* TODO: P-1 PdM文言確定 */}
      </SecondaryButton>
    </Flex>
  )
}
